import React from 'react';
import PopPop from 'react-poppop';

const contentStyle = {
	borderRadius: 0,
	minWidth: '300px',
	maxWidth: '450px',
	padding: '1.8rem 2rem 1.5rem',
};

const ConfirmModal = ({ isOpen, onCancel, onProceed, children }) => {
	return (
		<PopPop
			open={isOpen}
			position="centerCenter"
			closeOnEsc={true}
			closeOnOverlay={true}
			onClose={onCancel}
			contentStyle={contentStyle}
		>
			<div className="pb-4 mb-1">{children}</div>
			<div>
				<button
					className="primary-button tiny right mb-0"
					onClick={onProceed}
				>
					Proceed
				</button>
				<button
					className="secondary-secondary tiny right mb-0 mr-2"
					onClick={onCancel}
				>
					Cancel
				</button>
			</div>
		</PopPop>
	);
};

export default ConfirmModal;
